module.exports = __webpack_public_path__ + "static/myPicture-b79a732b08ffe80681c40632883ba53f.jpeg";